export class FilterModel {

    // Properties
    value: string;
    column: string;
    operator: string;
    dataType: string;
    dateValue: Date;
    columnIndex: number;

    // Class Functions
    constructor(value: string, column: string, operator: string, dataType: string, dateValue?: Date) {
        this.value = value;
        this.column = column;
        this.operator = operator;
        this.dataType = dataType;
        if (dateValue != undefined) {
        this.dateValue = dateValue;
        }
    }
}
